const i18n = {
  'activateAccount': {
    'form': {
      'loading': '驗證中...',
      'success': '成功啟用帳號',
      'register': '註冊帳號',
    },
    'error': {
      'invalidToken': '無效的 Token',
      'tokenExpired': '啟用帳號的連結已失效',
    }
  }
};
export default i18n;
